export default "__VITE_ASSET__BGtAXmOY__"